import { api, apiV2, apiV2Uberall, apiV2Gbm, catchHandler } from '@helpers/axios'
import { objToUrlParams } from '@helpers/index'
import config from '@config/index'
import { getV2ConfigCatValue } from '@helpers/utility'
import { getFeatureVal, featureFlags } from '@helpers/configcat'

export function fetchBusinessSettings(payload) {
  return api()
    .get(`${config.routes.businessSettings}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getsettings(payload) {
  return api()
    .get(`${config.routes.getsettings}?option_key=${payload}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function triggerContactSales(payload) {
  return api()
    .post(config.routes.triggerContactSales)
    .then((res) => res.data)
    .catch(catchHandler)
}
export async function updateBusinessSettings(payload) {
  let callV2flag = true
  const requestURlV2 = `${config.routes.gmbDataSyncV2}${config.routes.businessSettings}/${payload._id}`
  let requestURl = `${config.routes.businessSettings}/${payload._id}`
  if (payload && payload.type) {
    if (payload.type === 'logoUpdate') {
      const userID = payload && payload._id
      requestURl = `${config.routes.businessSettings}/${userID}/logo`
      callV2flag = false
      delete payload.type
    }
  }
  if (payload.updatetType === 'coverImageUpdate') {
    const userID = payload && payload._id
    requestURl = `${config.routes.businessSettings}/${userID}/cover`
    callV2flag = false
    delete payload.updatetType
  }
  if (payload.throwBackErr) {
    delete payload.throwBackErr
  }

  delete payload._id
  if (!requestURl.includes('cover')) delete payload.type

  const value = await getV2ConfigCatValue('BusinessSettings')
  if (value && callV2flag) {
    return apiV2()
      .put(requestURlV2, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return api()
      .put(requestURl, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  }
}
export function fetchSummaryReports(payload) {
  return api()
    .get(`${config.routes.accountSettings}/getaccountsettings/${payload._id}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateSummaryReports(payload) {
  return api()
    .put(`${config.routes.accountSettings}/updateaccountsettings/${payload._id}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getServiceAreas(payload) {
  const userID = payload && payload.user
  const locationId = payload && payload.location
  delete payload.user
  delete payload.location
  return api()
    .put(`${config.routes.businessSettings}/${locationId}/users/${userID}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
// Read-only: resolve covered service-area locations for a radius WITHOUT persisting.
// Backing endpoint: GET /business-settings/{locationId}/resolve-area/{userId}?radius=&unit=&zip=
// The resolver reads `radius`/`unit`/`zip` from the query string. `zip` is the on-screen (possibly unsaved)
// value and is required — the resolver anchors the preview on it and does NOT fall back to the stored ZIP.
export function resolveServiceArea(payload) {
  const userID = payload && payload.user
  const locationId = payload && payload.location
  const query = objToUrlParams({ radius: payload.radius, unit: payload.unit, zip: payload.zip })
  return api()
    .get(`${config.routes.businessSettings}/${locationId}/resolve-area/${userID}?${query}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getStaffUsers(data) {
  return api()
    .get(`${config.routes.getcustomers}?${objToUrlParams(data)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getCustomFields() {
  return api()
    .get(`${config.routes.getCustomFields}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getCustomField(fieldId) {
  return api()
    .get(`${config.routes.getCustomFields}/${fieldId}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function deleteCustomField(fieldId) {
  return api()
    .delete(`${config.routes.deleteCustomField}/${fieldId}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function activities(data) {
  return api()
    .get(`${config.routes.activities}?${objToUrlParams(data)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateBusinessImage(payload) {
  const userID = payload && payload._id
  delete payload._id
  return api()
    .put(`${config.routes.businessSettings}/${userID}/logo`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getCategories(payload) {
  return api()
    .get(`${config.routes.businessSettings}/categories?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getOnboardingCategories(payload) {
  return api()
    .get(`${config.routes.businessSettings}/onBoardingcategories?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function updateMediaPhotoName(payload) {
  const userID = payload._id
  const data = { description: payload.description }
  if (!payload.id) data.url = payload.url

  return api()
    .put(`${config.routes.businessSettings}/${userID}/photo/${payload.id}`, data)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function deleteMediaPhoto(payload) {
  const userID = payload._id
  const data = {}
  if (!payload.id) data.url = payload.url

  return api()
    .delete(`${config.routes.businessSettings}/${userID}/photo/${payload.id}`, { data })
    .then((res) => res.data)
    .catch(catchHandler)
}
export async function deleteMediaVideo(payload) {
  const userID = payload._id
  const value = await getV2ConfigCatValue('BusinessSettings')
  if (value) {
    return apiV2()
      .put(`${config.routes.gmbDataSyncV2}/${config.routes.businessSettings}/${userID}`, payload.videoUrls)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return api()
      .put(`${config.routes.businessSettings}/${userID}`, payload.videoUrls)
      .then((res) => res.data)
      .catch(catchHandler)
  }
}
export function updateStaffStatus(payload) {
  const userID = payload._id
  delete payload._id
  return api()
    .put(`${config.routes.updateStaffStatus}/${userID}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function connectFacebook(payload) {
  return api()
    .get(`${config.facebook_graph_url}accounts?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export async function facebookSync(payload) {
  const value = await getV2ConfigCatValue('FB')
  if (value) {
    return apiV2()
      .post(`${config.routes.facebookDataSyncV2}/user-sync-facebook`, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return api()
      .post(`${config.routes.businessSettings}/user-sync-facebook`, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  }
}
export function getSocialConnections(payload) {
  return api()
    .get(`${config.routes.businessSettings}/${payload.id}/social-connections`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export async function facebookUnSync(payload) {
  const value = await getV2ConfigCatValue('FB')
  if (value) {
    return apiV2()
      .post(`${config.routes.facebookDataSyncV2}/user-unsync-facebook`, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return api()
      .post(`${config.routes.businessSettings}/user-unsync-facebook`, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  }
}

export async function disconnectPlatformAndSave(payload) {
  const { locationId, platform } = payload
  return apiV2()
    .put(`${config.routes.gmbDataSyncV2}/business-settings/${locationId}/disconnect-platform-and-save`, {
      platform,
      saveChanges: true
    })
    .then((res) => res.data)
    .catch(catchHandler)
}
export function fetchSmsTheme(payload) {
  return api()
    .get(`${config.routes.settings}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function resetUserAccount(payload) {
  return api()
    .post(`${config.routes.resetUserAccount}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function quickLogin(payload) {
  return api()
    .post(`${config.routes.quickLogin}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function createStaff(payload) {
  return api()
    .post(`${config.routes.createStaff}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function createCustomField(payload) {
  return api()
    .post(`${config.routes.createCustomField}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function editCustomField(payload) {
  return api()
    .patch(`${config.routes.createCustomField}/${payload.customFieldId}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function fetchUserRolePermissions(payload) {
  return api()
    .get(`${config.routes.userRolePermissions}/userpermission?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getGmbAccounts(payload) {
  return api(true)
    .post(config.routes.gmbData, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
// nedd to change in feature
export function getGMBDetailsFromGoogle(payload) {
  console.log('[getGMBDetailsFromGoogle] : API call START ====================')
  console.log('[getGMBDetailsFromGoogle] : Payload : ', JSON.stringify(payload, null, 2))
  console.log(
    '[getGMBDetailsFromGoogle] : API URL : ',
    `${config.routes.gmbLocationsDetails}?${objToUrlParams(payload)}`
  )
  return api('', payload)
    .get(`${config.routes.gmbLocationsDetails}?${objToUrlParams(payload)}`)
    .then((res) => {
      console.log('[getGMBDetailsFromGoogle] : API RESPONSE START ====================')
      console.log('[getGMBDetailsFromGoogle] : Response data : ', JSON.stringify(res.data, null, 2))
      console.log('[getGMBDetailsFromGoogle] : API RESPONSE END ====================')
      return res.data
    })
    .catch((error) => {
      console.error('[getGMBDetailsFromGoogle] : API ERROR START ====================')
      console.error('[getGMBDetailsFromGoogle] : Error : ', JSON.stringify(error, null, 2))
      console.error('[getGMBDetailsFromGoogle] : API ERROR END ====================')
      return catchHandler(error)
    })
}
// export function getGMBDetailsFromGoogle (payload) {
//   return api('', payload)
//     .get(`https://mybusinessaccountmanagement.googleapis.com/v1/accounts`)
//     .then((res) => res.data)
//     .catch(catchHandler)
// }
export function getGmbLocations(payload) {
  console.log('[getGmbLocations] : API call START ====================')
  console.log('[getGmbLocations] : Payload : ', JSON.stringify(payload, null, 2))
  console.log('[getGmbLocations] : API URL : ', `${config.routes.gmbLocations}?${objToUrlParams(payload)}`)
  return api()
    .get(`${config.routes.gmbLocations}?${objToUrlParams(payload)}`)
    .then((res) => {
      console.log('[getGmbLocations] : API RESPONSE START ====================')
      console.log('[getGmbLocations] : Response data : ', JSON.stringify(res.data, null, 2))
      if (res.data && res.data.data && Array.isArray(res.data.data)) {
        console.log('[getGmbLocations] : Total locations received : ', res.data.data.length)
        res.data.data.forEach((location, index) => {
          console.log(`[getGmbLocations] : ========== LOCATION #${index + 1} START ==========`)
          console.log(`[getGmbLocations] : Location #${index + 1} : Name : `, location.name)
          console.log(`[getGmbLocations] : Location #${index + 1} : Title : `, location.title)
          console.log(
            `[getGmbLocations] : Location #${index + 1} : Phone Numbers : `,
            JSON.stringify(location.phoneNumbers)
          )
          console.log(`[getGmbLocations] : Location #${index + 1} : Categories : `, JSON.stringify(location.categories))
          console.log(
            `[getGmbLocations] : Location #${index + 1} : Storefront Address : `,
            JSON.stringify(location.storefrontAddress)
          )
          console.log(`[getGmbLocations] : Location #${index + 1} : Website URI : `, location.websiteUri)
          console.log(`[getGmbLocations] : Location #${index + 1} : Metadata : `, JSON.stringify(location.metadata))
          console.log(`[getGmbLocations] : Location #${index + 1} : Full Data : `, JSON.stringify(location, null, 2))
          console.log(`[getGmbLocations] : ========== LOCATION #${index + 1} END ==========`)
        })
      }
      console.log('[getGmbLocations] : API RESPONSE END ====================')
      return res.data
    })
    .catch((error) => {
      console.error('[getGmbLocations] : API ERROR START ====================')
      console.error('[getGmbLocations] : Error : ', JSON.stringify(error, null, 2))
      console.error('[getGmbLocations] : Error message : ', error.message)
      console.error('[getGmbLocations] : API ERROR END ====================')
      return catchHandler(error)
    })
}
export async function gmbImport(payload) {
  const value = await getV2ConfigCatValue('GMB')
  if (value) {
    return apiV2()
      .post(`${config.routes.gmbDataSyncV2}/user-sync-google`, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return api()
      .post(`${config.routes.businessSettings}/user-sync-google`, payload)
      .then((res) => res.data)
      .catch(catchHandler)
  }
}
export function userRolePermissions(payload) {
  return api()
    .post(`${config.routes.userRolePermissions}/userpermission`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function gmbSync(payload) {
  return api()
    .post(`${config.routes.accountSettings}/syncgmbsettings`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export async function gmbUnSync(payload) {
  const value = await getV2ConfigCatValue('GMB')
  if (value) {
    return apiV2()
      .post(`${config.routes.gmbDataSyncV2}/user-unsync-google`)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return api()
      .post(`${config.routes.businessSettings}/user-unsync-google`)
      .then((res) => res.data)
      .catch(catchHandler)
  }
}
export function gmbActive(payload, rootState) {
  return apiV2Gbm()
    .get('/gmb-active')
    .then((res) => res.data)
    .catch(catchHandler)
}
export function gbmEnabled(payload, rootState) {
  return apiV2Gbm()
    .get('/gbm-enabled')
    .then((res) => res.data)
    .catch(catchHandler)
}
export function createGbmAgent(payload, rootState) {
  return apiV2Gbm()
    .post('/create-gbm-agent', payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateGbmAgent(payload, rootState) {
  return apiV2Gbm()
    .put('/update-gbm-agent', payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getGmbDataOfUser(payload, rootState) {
  return apiV2Gbm()
    .get('/gmb-link-details')
    .then((res) => res.data)
    .catch(catchHandler)
}
export async function getConfigCatValue(flag, payload) {
  if (flag === 'gbmEnabled') {
    const configCatRes = await getFeatureVal(featureFlags.gbmEnabled, payload)
    return configCatRes
  }
  if (flag === 'syncWithThirdPartiesSynchronously') {
    const configCatRes = await getFeatureVal(featureFlags.syncWithThirdPartiesSynchronously, payload)
    return configCatRes
  }
  return false
}
export function getEmbedChatScript(payload) {
  console.log(payload)

  return api()
    .get(`${config.routes.messengerEmbedcode}`, { params: payload })
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getEmbedBookingScript(payload) {
  return api()
    .get(`${config.routes.bookingEmbedCode}`, { params: payload })
    .then((res) => res.data)
    .catch(catchHandler)
}
export function sortPhotos(payload) {
  const requestURL = `${config.routes.businessSettings}/${payload._id}/sort-photo`
  delete payload._id
  return api()
    .put(requestURL, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function uploadBusinessPhoto(payload) {
  const requestURL = `${config.routes.businessSettings}/${payload._id}/photo`
  delete payload._id
  return api()
    .put(requestURL, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getMenuLocations(payload) {
  const requestURL = `${config.routes.menuLocation}/${payload}`
  return api()
    .get(requestURL, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getUser(payload) {
  return api()
    .get(`${config.routes.getUser}/${payload._id}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getCalendarData(payload) {
  return api()
    .get(`${config.routes.getCalendarData}/${payload._id}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateStaffUser(payload) {
  return api()
    .put(`${config.routes.updateStaff}/${payload._id}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function sendWelcomeMessage(payload) {
  return api()
    .post(`${config.routes.sendWelcome}/${payload._id}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getActivityList(payload) {
  return api()
    .get(`${config.routes.activities}?${objToUrlParams(payload.query)}&activity_type=${payload.activity_type}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function unLinkCalendar(payload) {
  return api()
    .delete(`${config.routes.unLinkCalendar}/${payload._id}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function addSectionitem(payload) {
  return api()
    .post(`${config.routes.addMenuSection}/${payload.id}`, payload.payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateSectionitem(payload) {
  return api()
    .put(`${config.routes.addMenuSection}/${payload.id}/${payload.payload._id}`, payload.payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getMenuOptions(payload) {
  return api()
    .get(config.routes.menuLabels)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function createMenuItem(payload) {
  return api()
    .post(`${config.routes.menuItems}/${payload.businessId}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateMenuItem(payload) {
  return api()
    .put(`${config.routes.menuItems}/${payload.businessId}/${payload.itemId}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function deleteMenuItem(payload) {
  return api()
    .delete(`${config.routes.menuItems}/${payload.section_id}/${payload._id}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function deleteMenuSection(payload) {
  return api()
    .delete(`${config.routes.addMenuSection}/${payload.activeMenuId}/${payload.sectionId}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function createMenu(payload) {
  return api()
    .post(`${config.routes.menuLocation}/${payload.id}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function editMenu(payload) {
  return api()
    .put(`${config.routes.menuLocation}/${payload.id}/${payload.menuId}`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function deleteMenu(payload) {
  return api()
    .delete(`${config.routes.menuLocation}/${payload.id}/${payload.menuId}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function reorderMenuItem(payload) {
  return api()
    .put(`${config.routes.addMenuSection}/${payload.id}/${payload.sectionId}/reorder`, payload.data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function syncGMBPhoto(payload) {
  const data = {}
  if (!payload.photoId) data.url = payload.url
  return api()
    .put(`${config.routes.businessSettings}/${payload.businessId}/photo/${payload.photoId}`, data)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function upadteBusinessName(payload) {
  return api()
    .post(`${config.routes.businessSettings}/`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function createGMBLocation(payload) {
  return api()
    .post(`${config.routes.businessSettingsAddGMB}/`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export async function uberAllCategory(payload, module) {
  const value = await getV2ConfigCatValue('uberallBanners')
  if (value) {
    return apiV2Uberall()
      .get(`${config.routes.uberAllCategories}/${payload}?module=${module}`)
      .then((res) => res.data)
      .catch(catchHandler)
  } else {
    return ''
  }
}
export function sendForwardPhoneOtp(locationId, payload) {
  return api()
    .post(`${config.routes.businessSettings}/${locationId}/verify-forward-phone`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function sendForwardPhoneOtpByCall(locationId, payload) {
  return api()
    .post(`${config.routes.businessSettings}/${locationId}/verify-forward-phone?otpbycall=1`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function verifyForwardPhoneOtp(locationId, payload) {
  return api()
    .post(`${config.routes.businessSettings}/${locationId}/verify-forward-phone-otp`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function deleteForwardPhone(locationId) {
  return api()
    .delete(`${config.routes.businessSettings}/${locationId}/forward-phone`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function updateBusinessArea(payload) {
  const userID = payload && payload.user
  const locationId = payload && payload.location
  delete payload.user
  delete payload.location
  return api()
    .put(`${config.routes.businessSettings}/${locationId}/business-area/${userID}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
